import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Modal as FlowbiteModal } from "flowbite-react";
import Close from "../../assets/close.svg";
import Temp from "../../assets/profile.svg";
import { shortenText } from "../../helpers/text";
import { formatUserPostBrand } from "../../helpers/users";
import React, { useState } from "react";
import { User } from "../../types/users";
import { removeParticipant } from "../../services/chats";
import DeleteIconRed from "../../assets/delete_red.svg";
import DeleteIcon from "../../assets/delete.svg";

interface RemoveModalProps {
    isOpen: boolean;
    onClose: () => void;
    user: User
    chat_pk: string
    claim_pk: string
}

export const RemoveParticipantModal = ({ isOpen, onClose, user, chat_pk, claim_pk }: RemoveModalProps) => {
    // Модальное окно удаления участника чата

    const queryClient = useQueryClient();
    // Запрос на удаление
    const { mutate: remove } = useMutation({
        mutationFn: removeParticipant,
        onSuccess: (data) => {
            queryClient.invalidateQueries({
                queryKey: ['chat', claim_pk.toString()],
                refetchType: 'all',
            });
        },
        onSettled: () => {
            // Заново обновляем состояние модели редактирования
            onClose()
        }
    });

    const handleRemove = () => {
        remove({
            userId: user?.pk || '',
            chatId: chat_pk
        })
    }

    return (
        <FlowbiteModal
            show={isOpen}
            onClose={onClose}
            size={'md'}
        >
            <div
                className="w-full inline-flex flex-col items-start p-8 relative bg-white rounded-lg overflow-hidden">
                {/*CONTAINER*/}
                <div className="w-full inline-flex flex-col items-start relative flex-[0_0_auto]">
                    {/*HEADER*/}
                    <div
                        className="
                        relative
                        w-full flex flex-row justify-end items-center text-black text-2xl
                        leading-[normal]
                        [font-family:'Acrom-Medium',Helvetica] font-medium tracking-[0]
                        "
                    >
                        {/*CLOSE BUTTON*/}
                        <button
                            onClick={onClose}
                            className="flex justify-center items-center w-8 h-8 top-2.5 bg-[#f2f2f2] rounded-lg overflow-hidden">
                            <img src={Close} className=" w-6 h-6" alt="Manager ic close" />
                        </button>
                    </div>
                    {/*BODY*/}
                    <div className="w-full inline-flex flex-col items-start gap-8 relative flex-[0_0_auto]">
                        {/*USER*/}
                        <div
                            className="w-full inline-flex flex-col mb-4 mt-1 items-start gap-5 relative flex-[0_0_auto]">
                            <div className="flex w-full p-1 justify-start items-center gap-3 rounded-lg bg-gray-100">
                                <img className="relative w-16 h-16 rounded-full"
                                    src={user?.photo_img?.file ?? Temp}
                                    alt="" />
                                <div className="flex flex-col w-auto items-start gap-0.5 relative">
                                    <div
                                        className="
                                        relative
                                        w-full
                                        text-black
                                        font-manager-acrom-ph1-16-medium-acrom
                                        leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)]
                                        [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]
                                        text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)]
                                        font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)]
                                        tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)]
                                        "
                                    >
                                        {shortenText(`${user?.last_name} ${user?.first_name} ${user?.middle_name}`, 64)}
                                    </div>
                                    <div
                                        className="
                                        relative
                                        w-full
                                        text-[#949494]
                                        font-manager-acrom-ph-14-medium-acrom
                                        leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]
                                        [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]
                                        text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)]
                                        font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)]
                                        tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]
                                        "
                                    >
                                        {shortenText(formatUserPostBrand(user), 64)}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*TEXT*/}
                        <div className=" text-2xl text-center">
                            Вы точно хотите удалить сотрудника?
                        </div>
                    </div>
                    {/*BUTTONS*/}
                    <div className="w-full flex flex-col mt-5 gap-5 justify-center items-center">
                        <button
                            onClick={handleRemove}
                            className="
                            w-full inline-flex flex-col items-start gap-2.5 px-5 py-3.5
                            relative
                            flex-[0_0_auto]
                            bg-[#fcd700] rounded-lg overflow-hidden
                            ">
                            <div
                                className="
                                w-full
                                flex
                                items-center
                                justify-center
                                font-manager-acrom-button4-16-medium-acrom
                                leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                "
                            >
                                Удалить
                            </div>
                        </button>
                        <button
                            onClick={onClose}
                            className="
                            w-full inline-flex flex-col
                            items-start
                            gap-2.5 px-5 py-3.5
                            relative
                            flex-[0_0_auto]
                            bg-gray-100
                            rounded-lg
                            overflow-hidden
                            ">
                            <div
                                className="
                                w-full
                                flex items-center justify-center
                                font-manager-acrom-button4-16-medium-acrom
                                leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                "
                            >
                                Отмена
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </FlowbiteModal>
    );
};

interface ParticipantsModalProps {
    isOpen: boolean;
    onClose: () => void;
    users: User[]
    chat_pk: string
    claim_pk: string
}

export const ParticipantsModal = ({ isOpen, onClose, users, chat_pk, claim_pk }: ParticipantsModalProps) => {
    // Модальное окно со списком участников чата

    const [isDisabled, setDisabled] = useState(false);
    const [usersToDelete, setUsersToDelete] = useState<string[]>([])

    const queryClient = useQueryClient();
    // Запрос на удаление
    const remove = useMutation({
        mutationFn: removeParticipant,
        onSuccess: (data) => {

        },
        onSettled: () => {
            // Заново обновляем состояние модели редактирования
        }
    });

    const handleMarkToDelete = (userId: string) => {
        const uniqueSet = new Set(usersToDelete)
        uniqueSet.add(userId)
        setUsersToDelete(Array.from(uniqueSet))
    }

    const handleClose = () => {
        setUsersToDelete([]);
        onClose();
    }
    const invalidateChat = () => {
        queryClient.invalidateQueries({
            queryKey: ['chat', claim_pk.toString()],
            refetchType: 'all',
        });
    }

    const handleSave = () => {
        // Запускаем параллельно запросы на удаление, ждём успех ото всех и закрываем, иначе не закрываем
        const promises = usersToDelete.map((userId) => remove.mutateAsync({
            userId: userId,
            chatId: chat_pk
        }));
        Promise.all(promises).then(() => {
            // При успехе инвалидируем чат и закрываем
            invalidateChat();
            setUsersToDelete([]);
            onClose();
        }).catch(e => {
            invalidateChat();
            setUsersToDelete([]);
        })
    }

    return (
        <FlowbiteModal
            show={isOpen}
            onClose={onClose}
            size={'md'}
        >
            <div
                className="w-full inline-flex flex-col items-start p-8 relative bg-white rounded-lg overflow-hidden">
                {/*CONTAINER*/}
                <div className="w-full inline-flex flex-col items-start relative flex-[0_0_auto]">
                    {/*HEADER*/}
                    <div
                        className="
                        relative
                        w-full flex flex-row justify-end items-center text-black text-2xl
                        leading-[normal]
                        [font-family:'Acrom-Medium',Helvetica]
                        font-medium
                        tracking-[0]
                        "
                    >
                        {/*CLOSE BUTTON*/}
                        <button
                            onClick={handleClose}
                            className="flex justify-center items-center w-8 h-8 top-2.5 bg-[#f2f2f2] rounded-lg overflow-hidden">
                            <img src={Close} className=" w-6 h-6" alt="Manager ic close" />
                        </button>
                    </div>
                    {/*BODY*/}
                    <div
                        className="w-full pt-2 inline-flex flex-col items-start max-h-[70vh] overflow-y-auto gap-1 relative flex-[0_0_auto]">
                        {/*USERS*/}
                        {users.filter(e => !usersToDelete.includes(e.pk)).map((user, index) => <div
                            key={index}
                            className="
                                    w-full
                                    inline-flex
                                    flex-row
                                    mb-4 mt-1
                                    items-start
                                    gap-5
                                    relative
                                    flex-[0_0_auto]
                                "
                        >
                            <div className="flex w-full p-1 justify-start items-center gap-3 rounded-lg bg-gray-100">
                                <img className="relative w-16 h-16 rounded-full flex-[0_0_auto]"
                                    src={user?.photo_img?.file ?? Temp}
                                    alt="" />
                                <div className="flex flex-col w-auto items-start gap-0.5 relative">
                                    <div
                                        className="
                                        relative
                                        w-full
                                        text-black
                                        font-manager-acrom-ph1-16-medium-acrom
                                        leading-[var(--manager-acrom-ph1-16-medium-acrom-line-height)]
                                        [font-style:var(--manager-acrom-ph1-16-medium-acrom-font-style)]
                                        text-[length:var(--manager-acrom-ph1-16-medium-acrom-font-size)]
                                        font-[number:var(--manager-acrom-ph1-16-medium-acrom-font-weight)]
                                        tracking-[var(--manager-acrom-ph1-16-medium-acrom-letter-spacing)]
                                        "
                                    >
                                        {shortenText(`${user?.last_name} ${user?.first_name} ${user?.middle_name}`, 64)}
                                    </div>
                                    <div
                                        className="
                                        relative
                                        w-full
                                        text-[#949494]
                                        font-manager-acrom-ph-14-medium-acrom
                                        leading-[var(--manager-acrom-ph-14-medium-acrom-line-height)]
                                        [font-style:var(--manager-acrom-ph-14-medium-acrom-font-style)]
                                        text-[length:var(--manager-acrom-ph-14-medium-acrom-font-size)]
                                        font-[number:var(--manager-acrom-ph-14-medium-acrom-font-weight)]
                                        tracking-[var(--manager-acrom-ph-14-medium-acrom-letter-spacing)]
                                        "
                                    >
                                        {shortenText(formatUserPostBrand(user), 64)}
                                    </div>
                                </div>
                                <button
                                    disabled={isDisabled}
                                    className='w-10 h-10 flex-[0_0_auto] flex justify-center items-center ml-auto'
                                    onClick={() => handleMarkToDelete(user.pk)}
                                >
                                    <img src={isDisabled ? DeleteIcon : DeleteIconRed} alt="" />
                                </button>
                            </div>
                        </div>
                        )}
                        {/*TEXT*/}
                    </div>
                    {/*BUTTONS*/}
                    <div className="w-full flex flex-col mt-5 gap-5 justify-center items-center">
                        <button
                            disabled={isDisabled || !usersToDelete.length}
                            onClick={handleSave}
                            className={`
                            w-full inline-flex flex-col items-start gap-2.5 px-5 py-3.5
                            relative
                            flex-[0_0_auto]
                            rounded-lg 
                            overflow-hidden
                            ${usersToDelete.length ? 'bg-melon-yellow' : 'bg-melon-light-grey'}
                            `}>
                            <div
                                className="
                                w-full
                                flex
                                items-center
                                justify-center
                                font-manager-acrom-button4-16-medium-acrom
                                leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                "
                            >
                                Сохранить
                            </div>
                        </button>
                        <button
                            onClick={handleClose}
                            className="
                            w-full inline-flex flex-col
                            items-start
                            gap-2.5 px-5 py-3.5
                            relative
                            flex-[0_0_auto]
                            bg-gray-100
                            rounded-lg
                            overflow-hidden
                            ">
                            <div
                                className="
                                w-full
                                flex items-center justify-center
                                font-manager-acrom-button4-16-medium-acrom
                                leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                "
                            >
                                Отмена
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </FlowbiteModal>
    );
};